import angular from 'angular';

const interceptedImages = {
    '/images/blur_admin/blur-bg.jpg': require('blur_admin/src/assets/img/blur-bg.jpg'),
    '/images/blur_admin/blur-bg-blurred.jpg': require('blur_admin/src/assets/img/blur-bg-blurred.jpg'),
    '/images/blur_admin/blur-bg-mobile.jpg': require('blur_admin/src/assets/img/blur-bg-mobile.jpg'),
};

let preloaderDecorator = function preloaderDecorator($delegate) {
    /** @ngInject */

    let coreLoadImg = $delegate.loadImg;
    $delegate.loadImg = function (path) {
        if (interceptedImages[path])
            coreLoadImg(interceptedImages[path]);
        else
            coreLoadImg(path);
    };
    return $delegate;
};

let preloaderConfig = function ($provide) {
    /** @ngInject */

    $provide.decorator('preloader', preloaderDecorator);
};

export default angular.module('cms.blur-admin.preloaderDecorator', [angular.module('BlurAdmin.theme').name])
    .config(preloaderConfig).name;


// WEBPACK FOOTER //
// ./src/cmsCore/BlurAdmin/preloaderDecorator/blurAdminLoaderDecorator.js